module.exports = __webpack_public_path__ + "img/logo.5647bf01.png";